module.exports = __webpack_public_path__ + "img/img_cs_phone_img2.82a76b84.png";